import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import axios from "axios";
import { API_URL } from "../../../config";
import HeaderThree from "../../../components/header/HeaderThree";
import {
  FaLinkedin,
  FaRegCopy,
  FaTelegram,
  FaTwitter,
  FaUserTie,
  FaWhatsapp,
} from "react-icons/fa";
import { MdCategory } from "react-icons/md";
import FooterTwo from "../../../components/footer/FooterTwo";
import CopyRightTwo from "../../../components/footer/CopyRightTwo";
import image from '../../../assets/images/icon/twitter.png'
import whatsapp from '../../../assets/Social_media_icons/whatsapp.svg'
import twitter from '../../../assets/Social_media_icons/twitter.svg'
import telegram from '../../../assets/Social_media_icons/telegram.svg'
import copy from '../../../assets/Social_media_icons/copy.svg'
import linkedin from '../../../assets/Social_media_icons/linkedin.svg'

const BlogDetails = () => {
  const [showIcons, setShowIcons] = useState(false);
  const containerRef = useRef(null);
  const toggleShareIcons = () => {
    setShowIcons(prev => !prev);
  };

  const handleCopy = () => {
    const url = window.location.href;

    navigator.clipboard
      .writeText(url)
      .then(() => {
        alert("URL copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };
  useEffect(() => {
    function handleClickOutside(event) {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setShowIcons(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const [data, setData] = useState([]);
  const { id } = useParams();
  const iconStyle = {
    width: '24px',
    height: '24px',
    objectFit: 'contain',
    transition: 'transform 0.3s ease',
  };


  useEffect(() => {
    const fetch = async () => {
      try {
        const { data } = await axios.get(
          `${API_URL}/api/blog/single-blog/${id}`
        );

        setData(data);
        console.log("this data comes from me ", data);
      } catch (err) {
        console.log(err);
      }
    };
    fetch();
  }, [id]);

  return (
    <div className="main-page-wrapper ">

      <Helmet>
        <title>Raiden Studios | Blockchain, DeFi, Gaming & VR Experts</title>
      </Helmet>
      <HeaderThree />

      <div style={{ height: "80px" }}></div>

      <div>
        <h1
          style={{
            fontSize: "2.5rem",
            fontWeight: "bold",
            textAlign: "center",
            marginBottom: "20px",
          }}
        >
          Blog Details
        </h1>
      </div>


      <div>
        <div className="container">
          <div className="bg-light p-4 shadow rounded-3 ">
            {data.singleBlog && (
              <div>
                <div>
                  <section className="row ">
                    <div>
                      <h2 className="h2-heading mb-2" style={{ textAlign: 'center' }}>
                        {" "}
                        {data.singleBlog.mainheading}
                      </h2>
                      <div className="d-flex justify-content-start align-items-center" style={{ gap: '15px', marginLeft: '18px' }}>
                        <span className="d-flex gap-1 align-items-center ">
                          <FaUserTie /> Reyansh Rao
                        </span>
                        <span className="ps-2 d-flex gap-1  align-items-center">
                          {" "}
                          <MdCategory />
                          {data.singleBlog.category}{" "}
                        </span>



                      </div>

                      <img
                        src={data.singleBlog.imageurl}
                        alt=""
                        className="mb-4" style={{ textAlign: 'center', width: '1106px' }}
                      />
                      <div className="position-relative mb-4">



                        <ul
                          className="position-absolute p-2 d-flex gap-2 align-items-center rounded "
                          style={{
                            height: "40px",
                            width: "169px",
                            marginTop: '-20px'

                          }}
                        >

                          <li>
                            <a
                              href="https://api.whatsapp.com/send?phone=919884036062&text=Unity%203D%20Game%20Development%20Company%20-%20RaidenStudios%20%0ahttps://raiden.studio/blogdetails/Unity-3d-game-development"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img src={whatsapp} alt="WhatsApp" style={iconStyle} />
                            </a>
                          </li>


                          <li>
                            <a
                              href="https://x.com/intent/post?url=https%3A%2F%2Fraiden.studio%2Fblogdetails%2FUnity-3d-game-development&text=Unity%203D%20Game%20Development%20Company%20-%20RaidenStudios"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img src={twitter} alt="Twitter" style={iconStyle} />
                            </a>
                          </li>


                          <li>
                            <a
                              href="https://telegram.me/share/url?url=https://raiden.studio/blogdetails/Unity-3d-game-development&text=Unity%203D%20Game%20Development%20Company%20-%20RaidenStudios"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img src={telegram} alt="Telegram" style={iconStyle} />
                            </a>
                          </li>


                          <li>
                            <a
                              href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(window.location.href)}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img src={linkedin} alt="LinkedIn" style={iconStyle} />
                            </a>
                          </li>


                          <li onClick={handleCopy} style={{ cursor: "pointer" }}>
                            <img src={copy} alt="Copy" style={iconStyle} />
                          </li>
                        </ul>

                      </div>


                      <div >

                      </div>
                      <p className="h1-para " style={{ marginTop: '51px', color: '#000000a3' }}>{data.singleBlog.maincontent}</p>
                    </div>

                  </section>

                  <div className=" mt-4 ">
                    <div
                      className="blog-content"
                      dangerouslySetInnerHTML={{
                        __html: data.singleBlog.content,
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* < share content >  */}

      {/* /.fancy-hero-two */}

      <footer className="theme-footer-two pt-80 padt">
        <div className="top-footer">
          <div className="container">
            <FooterTwo />
          </div>
        </div>
        <div className="container">
          <div className="bottom-footer-content">
            <CopyRightTwo />
          </div>
        </div>
      </footer>
    </div>
  );
};

export default BlogDetails;
